import { render, staticRenderFns } from "./MsgSimpleDialog.vue?vue&type=template&id=fdec032e"
import script from "./MsgSimpleDialog.vue?vue&type=script&lang=js"
export * from "./MsgSimpleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports